const useUserSearch = () => {
  const searchList = (list, input) => list.filter((x) => (`${x.fetchUser.firstname} ${x.fetchUser.lastname} ${x.fetchUser.code}`).toLowerCase().includes(input)).sort(
    (a, b) => (`${a.fetchUser.firstname} ${a.fetchUser.lastname}`).localeCompare((`${b.fetchUser.firstname} ${b.fetchUser.lastname}`)),
  );
  return searchList;
};

export default useUserSearch;
